import React from 'react'
import ViemoIcon from '../ViemoIcon/ViemoIcon'

const Viemo = ({icon, videoId, label}) => {
  return (
    <div style={{display: 'flex', gap:'8px', alignItems: 'center'}}>
        <ViemoIcon icon={icon} videoId={videoId}/>
        <div>{label}</div>
    </div>
  )
}

export default Viemo